import { render, staticRenderFns } from "./FoodMenuType.vue?vue&type=template&id=8a0c78de&scoped=true"
import script from "./FoodMenuType.vue?vue&type=script&lang=js"
export * from "./FoodMenuType.vue?vue&type=script&lang=js"
import style0 from "./FoodMenuType.vue?vue&type=style&index=0&id=8a0c78de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c78de",
  null
  
)

export default component.exports